// extracted by mini-css-extract-plugin
module.exports = {"imageInputLabel":"ImageInput_imageInputLabel__3vbIv"};